<template>
    <div class="animate-pulse space-y-2">
        <div
            v-for="row in rows"
            :key="row"
            class="h-4 rounded bg-gray-200"
            :class="row % 2 === 0 ? 'w-2/3' : 'w-full'"
        />
    </div>
</template>

<script>
export default {
    props: {
        rows: { type: Number, default: 3 },
    },
};
</script>
